import { createSlice } from '@reduxjs/toolkit';
import { fetchClaims } from 'common/services/api/Claims/Claims.thunk';
import { Claim } from 'common/types/Entities';
import { createLoadedExtraReducers } from 'common/utils/sliceUtils/entitySliceUtils';
import { createDropdownFilterReducers, DropdownFilterState } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

type ClaimsState = DropdownFilterState & {
    claims: Claim[],
    loaded: boolean,
};

const initialState: ClaimsState = {
    claims: [],
    loaded: false,
    filters: {
        keywords: [],
        dropdowns: {
            claimDataTypeName: {
                keys: [],
                asKeyword: false
            }
        }
    }
};

const claimsSlice = createSlice({
    name: 'claims',
    initialState,
    reducers: () => ({
        ...createDropdownFilterReducers(initialState),
    }),

    extraReducers: builder => {
        createLoadedExtraReducers<Claim>(builder, fetchClaims, 'claims');
    }
});

// eslint-disable-next-line no-restricted-syntax
export default claimsSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, checkClaimTypeFilter } = claimsSlice.actions;
export const selectFilters = (state: RootState) => state.claims.filters;
export const selectClaims = (state: RootState) => state.claims.claims;
